<template>
    <div class="clearfix company-form-container bg-transparent no-shadow reports-tab-nav rounded mt-4 pb-5 mx-auto px-3 template-wrapper employee-table-wrapper">
        <!-- Afrin :update 6-9 -->
        <div class="custom-loader-wrapper" v-if="download_loader">
            <div class="text-center">
                <span class="d-block max-450">{{ download_text }}</span>
                <img :src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Please click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button class="mb-1" target="_blank" :href="$api_url+'/company/dashboard'">Dashboard</b-button>
            </div>
        </div>
        <!-- Afrin :update 6-9 -->
        <!-- afrin 6-11 -->
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <img :src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
        </div>
        <!-- afrin 6-11 -->
        <div class="row no-gutters py-2 mb-3 align-items-center trz_ppl_wrapper_2">
            <!-- <div class="col-sm-1 pr-2">
                <b-form-select v-model="filter_year" :options="fiscal_years" class="custom-select" @change="resetPagination()">
                    <template #first>
                        <b-form-select-option value="">Select Year</b-form-select-option>
                    </template>
                </b-form-select>
            </div>
            <div class="col-sm-1 pr-2">
                <b-form-select v-model="filter_month" :options="months" class="custom-select" @change="resetPagination()"></b-form-select>
            </div> -->
            <!-- Afrin :update 6-9 start -->
            <div class="col-sm-2 pr-2">
                <b-form-select v-model="filter_status" class="custom-select" @change="resetPagination()">
                    <b-form-select-option value="">Select Status</b-form-select-option>
                    <b-form-select-option value="0">Pending</b-form-select-option>
                    <b-form-select-option value="1">Approved</b-form-select-option>
                    <b-form-select-option value="2">Rejected</b-form-select-option>
                </b-form-select>
            </div>
            <!-- Afrin :update 6-9 start -->
            <div class="col-sm-1 pr-2 mt-2 mt-sm-0">
                <b-dropdown text="Email" class="trz-custom-dropdown w-100" variant="secondary" :disabled="selectedNocIds.length === 0">
                    <!-- <b-dropdown-item @click="bulkEmail(1)"><b-icon icon="envelope" class="mr-2"></b-icon>Save to Employee Profile and Email</b-dropdown-item> -->
                    <b-dropdown-item @click="bulkEmail(0)"><b-icon icon="envelope" class="mr-2"></b-icon>Email Selected</b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="col-sm-1 pr-2 mt-2 mt-sm-0">
                <b-dropdown text="Download" class="trz-custom-dropdown w-100" variant="secondary" :disabled="selectedNocIds.length === 0">
                    <!-- <b-dropdown-item @click="bulkDownload(1)"><b-icon icon="box-arrow-in-down" class="mr-2"></b-icon>Save to Employee Profile and Download</b-dropdown-item> -->
                    <b-dropdown-item @click="bulkDownload(0)"><b-icon icon="box-arrow-in-down" class="mr-2"></b-icon>Download Selected</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="row no-gutters py-2 mb-3 align-items-center">
            <div class="col-sm-6 pl-0">
                <div class="align-self-center custom-search pr-0 mt-2" style="max-width: 480px; width: 100%;">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-6 pr-0 d-flex justify-content-end align-items-center mt-2 ">
                <div class="d-inline-block" style="vertical-align: top;">
                    <span v-if="selectedNocIds.length > 0" class="mr-2 font-weight-bold" style="line-height: 38px;">
                        {{ selectedNocIds.length }} selected
                    </span>
                    <b-dropdown text="Bulk Action" variant="primary" class="trz-custom-dropdown mb-1 custom-primary-dropdown-btn" right :disabled="selectedNocIds.length === 0">
                        <b-dropdown-item @click="bulkApprove(1)">Approve Selected</b-dropdown-item>
                        <b-dropdown-item @click="bulkApprove(2)">Reject Selected</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>

        <!-- Abdullah removed table-sticky-height  -->
        <div class="no-overflow ">
            <!-- Abdullah added class dataTbale to add sorting icon -->
            <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table dataTable">
                <thead>
                    <tr class="table-head">
                        <td class="checkbox-col">
                            <input type="checkbox" v-model="selectAll">
                            <label></label>
                        </td>
                        <!-- Abdullah warp every th name into span to add sorting icon  -->
                        <th @click="sortBy('employee_name')"
                            :class="sortKey === 'employee_name' ? (sortOrders['employee_name'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Employee Name</span></th>
                        <th @click="sortBy('employee_code')"
                            :class="sortKey === 'employee_code' ? (sortOrders['employee_code'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Employee Code</span></th>
                        <th @click="sortBy('jobposition')"
                            :class="sortKey === 'jobposition' ? (sortOrders['jobposition'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Job Position</span></th>
                        <th @click="sortBy('worklocation')"
                            :class="sortKey === 'worklocation' ? (sortOrders['worklocation'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Work Location</span></th>
                        <th @click="sortBy('noc_type')"
                            :class="sortKey === 'noc_type' ? (sortOrders['noc_type'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>NOC Type</span></th>
                        <th @click="sortBy('visiting_purpose')"
                            :class="sortKey === 'visiting_purpose' ? (sortOrders['visiting_purpose'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Purpose of Visit</span></th>
                        <th @click="sortBy('updated_at')"
                            :class="sortKey === 'updated_at' ? (sortOrders['updated_at'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Submitted On</span></th>
                        <th @click="sortBy('status')"
                            :class="sortKey === 'status' ? (sortOrders['status'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><span>Status</span></th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="noc in paginatedData" :key="noc.id" class="hover-bg table-row border-bottom mx-2">
                        <td class="checkbox-col">
                            <input type="checkbox" :value="noc.id" v-model="selectedNocIds">
                            <label></label>
                        </td>
                        <td>{{ noc.employee ? noc.employee.name : '' }}</td>
                        <!-- Afrin :update 6-9 -->
                        <td>{{ noc.employee ? noc.employee.employee_code : '' }}</td>
                        <td>{{ noc.employee && noc.employee.jobposition ? noc.employee.jobposition.name : '' }}</td>
                        <td>{{ noc.employee && noc.employee.branch ? noc.employee.branch.name : '' }}</td>
                        <td>{{ noc.noc_type === 'general' ? 'General' : 'Travel' }}</td>
                        <td v-b-tooltip.hover :title="noc.visiting_purpose" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            {{ noc.visiting_purpose }}
                        </td>
                        <td>{{ format_date(noc.created_at) }}</td>
                        <!-- <td>
                            <template v-if="noc.status == 1">
                                <b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon>
                            </template>
                            <template v-else-if="noc.status == 2">
                                <b-icon icon="x-circle-fill" variant="danger" class="mr-2"></b-icon>
                            </template>
                            <template v-else>
                                <b-icon icon="dash-circle-fill" variant="warning" class="mr-2"></b-icon>
                            </template>
                            {{ statusMap[noc.status] }}
                        </td> -->

                        <td class="text-center status-wrapper" :class="statusMap[noc.status] ? statusMap[noc.status].toLowerCase() : ''">
                            <span class="leave-status">
                                <i class="fa fa-circle mr-1"></i>{{ statusMap[noc.status] }}
                            </span>
                        </td>
                        <td class="cursor-pointer trz_relative">
                            <div class="col-sm text-right clearfix align-self-center">
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                    style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false" v-if="noc.status != 1">
                                    <b-icon icon="three-dots-vertical"></b-icon>
                                </a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown" v-if="noc.status != 1">
                                    <b-button-group>
                                        <b-button variant="outline-secondary" title="Approve" @click="approveNoc(noc.id, 1)"
                                            v-if="noc.status == 0">
                                            <b-icon icon="check2-circle"></b-icon> Approve
                                        </b-button>
                                        <b-button variant="outline-secondary" title="Reject" @click="approveNoc(noc.id, 2)"
                                            v-if="noc.status == 0">
                                            <b-icon icon="x-circle"></b-icon> Reject
                                        </b-button>
                                        <b-button variant="outline-secondary" title="Edit" @click="editNoc(noc.id)" v-if="noc.status == 0">
                                            <b-icon icon="pencil"></b-icon> Edit
                                        </b-button>
                                        <b-button variant="outline-secondary" title="Delete" @click="deleteNoc(noc.id)" v-if="noc.status != 1">
                                            <b-icon icon="trash"></b-icon> Delete
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="filteredData.length == 0">
                        <td colspan="10" class="text-center">No NOC documents found.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row py-2 no-margin" v-if="filteredData.length > 0">
            <div class="col-md-12 p-0 no-margin">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                    <li class="page-item disabled m-2">View</li>
                    <li class="page-item disabled">
                        <b-form-select v-model="length" :options="length_options" @change="resetPagination()"></b-form-select>
                    </li>
                    <li class="page-item disabled m-2">per page. Total {{ filteredData.length }} records
                        found.</li>
                </ul>
                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                    :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number
                    last-number></b-pagination-nav>
            </div>
        </div>

        <b-modal id="bv-modal-noc" size="lg" hide-footer title="Edit NOC Application">
            <b-form @submit.stop.prevent="onSubmit">
                <div class="row">
                    <div class="col-md-12">
                        <b-form-group class="noc-tab-legends">
                            <b-form-radio-group
                                class="noc-tab-btns w-100"
                                v-model="fdata.noc_type"
                                buttons button-variant="outline-secondary"
                                name="noc_type"
                                v-validate="'required'"
                                data-vv-as="NOC Type"
                                :state="validateState('noc_type')"
                                :disabled="fdata.id !== null"
                            >
                                <b-form-radio value="general"><span>General NOC</span></b-form-radio>
                                <b-form-radio value="travel"><span>Travel NOC</span></b-form-radio>
                            </b-form-radio-group>
                            <b-form-invalid-feedback>
                                {{ veeErrors.first('noc_type') }}
                            </b-form-invalid-feedback>
                        </b-form-group>

                    </div>
                    <!-- Passport No (Travel only) -->
                    <div class="col-md-6" v-if="fdata.noc_type === 'travel'">
                        <b-form-group class="required-field">
                            <template #label>
                                Passport No.* <small class="text-muted" style="font-size: 11px; font-weight: normal; font-style: italic;">(from your employee profile)</small>
                            </template>
                            <b-form-input
                                v-model="fdata.passport_no"
                                v-validate="'required'"
                                name="passport_no"
                                :state="validateState('passport_no')"
                                disabled
                            ></b-form-input>

                            <b-form-invalid-feedback>
                                {{ veeErrors.first('passport_no') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <!-- NEW: Nationality Field -->
                    <div class="col-md-6" v-if="fdata.noc_type === 'travel'">
                        <b-form-group class="required-field">
                            <template #label>
                                Nationality * <small class="text-muted" style="font-size: 11px; font-weight: normal; font-style: italic;">(from your employee profile)</small>
                            </template>
                            <b-form-input
                                v-model="fdata.nationality"
                                v-validate="'required'"
                                name="nationality"
                                :state="validateState('nationality')"
                                disabled
                            ></b-form-input>
                            <b-form-invalid-feedback>{{ veeErrors.first('nationality') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <!-- Passport Dates (Travel only) -->
                    <template v-if="fdata.noc_type === 'travel'">
                        <div class="col-md-6">
                            <b-form-group label="Passport Issue Date *" class="required-field">
                                <b-input-group>
                                    <b-form-input v-model="fdata.passport_issue_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text" name="passport_issue_date"
                                        data-vv-as="Passport Issue Date"
                                        placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('passport_issue_date')"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker v-model="fdata.passport_issue_date" button-only right
                                            reset-button close-button locale="en"
                                            name="passport_issue_date_picker"
                                            :max="maxPassportIssueDate"></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback :state="validateState('passport_issue_date')">{{ veeErrors.first('passport_issue_date') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Passport Expiry Date *" class="required-field">
                                <b-input-group>
                                    <b-form-input v-model="fdata.passport_expiry_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text"
                                        name="passport_expiry_date" data-vv-as="Passport Expiry Date" placeholder="YYYY-MM-DD"
                                        autocomplete="off" :state="validateState('passport_expiry_date')"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker v-model="fdata.passport_expiry_date" button-only right
                                            reset-button close-button locale="en"
                                            name="passport_expiry_date_picker"></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback :state="validateState('passport_expiry_date')">{{ veeErrors.first('passport_expiry_date') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </template>

                    <!-- Purpose and Country -->
                    <div :class="fdata.noc_type === 'general' ? 'col-md-12' : 'col-md-6'">
                        <b-form-group label="Purpose *" class="required-field">
                            <b-form-input v-model="fdata.visiting_purpose" v-validate="'required'"
                                name="visiting_purpose" data-vv-as="Purpose" :state="validateState('visiting_purpose')"></b-form-input>
                            <b-form-invalid-feedback>{{ veeErrors.first('visiting_purpose')
                                }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6" v-if="fdata.noc_type === 'travel'">
                        <b-form-group label="Country's of Visit *" class="required-field">
                            <b-form-select v-model="temp_country" :options="countries"
                                :state="validateState('visiting_destination')" @change="onCountrySelect">
                                <template #first>
                                    <b-form-select-option :value="null">Select Country</b-form-select-option>
                                </template>
                            </b-form-select>
                            <input type="hidden" name="visiting_destination" v-model="fdata.visiting_destination" v-validate="'required'" data-vv-as="Country of Visit" />
                            <b-form-invalid-feedback>{{ veeErrors.first('visiting_destination') }}</b-form-invalid-feedback>
                            <div v-if="selectedCountries.length > 0" class="mt-2 d-flex flex-wrap">
                                <!-- // Afrin: edited 6-25-26 start -->
                                <span v-for="(country, index) in selectedCountries" :key="index" class="badge badge-info mr-2 mb-2 p-2 px-3 rounded-pill" style="font-size: 13px; display: inline-flex; align-items: center; background-color: #e8f0fe; color: #0d6efd; border: 1px solid #0d6efd;">
                                    {{ getCountryText(country) }}
                                    <b-icon icon="x" class="ml-2 cursor-pointer font-weight-bold" style="color: #0d6efd;" @click="removeCountry(country)"></b-icon>
                                </span>
                                <!-- // Afrin: edited 6-25-26 end -->
                            </div>
                        </b-form-group>
                    </div>

                    <!-- Start & End Date Fields (Always visible for both General and Travel types) -->
                    <div class="col-md-6">
                        <b-form-group label="Start Date *" class="required-field">
                            <b-input-group>
                                <b-form-input v-model="fdata.visiting_from_date" v-validate="'required|date_format:yyyy-MM-dd'"
                                    name="visiting_from_date" data-vv-as="Start Date" :state="validateState('visiting_from_date')" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="fdata.visiting_from_date" button-only right reset-button
                                        close-button locale="en" name="visiting_from_date_picker"
                                        :max="fdata.noc_type === 'travel' ? fdata.passport_expiry_date : null"></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback :state="validateState('visiting_from_date')">{{ veeErrors.first('visiting_from_date')
                                }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="End Date *" class="required-field">
                            <b-input-group>
                                <b-form-input v-model="fdata.visiting_to_date" v-validate="'required|date_format:yyyy-MM-dd'"
                                    name="visiting_to_date" data-vv-as="End Date" :state="validateState('visiting_to_date')" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="fdata.visiting_to_date" button-only right reset-button
                                        close-button locale="en" name="visiting_to_date_picker"
                                        :max="fdata.noc_type === 'travel' ? fdata.passport_expiry_date : null"></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback :state="validateState('visiting_to_date')">{{ veeErrors.first('visiting_to_date')
                                }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>

                <div class="mt-4 text-center">
                    <b-button variant="primary" type="submit" class="px-5">Save</b-button>
                    <b-button variant="secondary" @click="$bvModal.hide('bv-modal-noc')" class="px-5 ml-2">Cancel</b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { update } from 'lodash';
import moment from 'moment';

export default {
    props: ['pageurl'],
    data() {
        return {
            noc_documents: [],
            selectedNocIds: [],
            months: [
                { value: 0, text: "All Months" }, { value: 1, text: "January" }, { value: 2, text: "February" },
                { value: 3, text: "March" }, { value: 4, text: "April" }, { value: 5, text: "May" },
                { value: 6, text: "June" }, { value: 7, text: "July" }, { value: 8, text: "August" },
                { value: 9, text: "September" }, { value: 10, text: "October" }, { value: 11, text: "November" },
                { value: 12, text: "December" }
            ],
            fiscal_years: this.$fiscal_year_options,
            filter_year: '',
            filter_month: 0,
            filter_status: '',
            search: '',
            fdata: {
                id: null,
                name: '',
                noc_type: 'general',
                nationality: '',
                passport_no: '',
                passport_issue_date: null,
                passport_expiry_date: null,
                visiting_destination: '',
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null,
                fiscal_year: '',
                month: ''
            },
            statusMap: {
                0: 'Pending',
                1: 'Approved',
                2: 'Rejected'
            },
            length: 20,
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            sortKey: 'id',
            sortOrders: {
                employee_name: 1,
                employee_code: 1,
                jobposition: 1,
                worklocation: 1,
                noc_type: 1,
                visiting_purpose: 1,
                updated_at: 1,
                status: 1,
                id: -1
            },
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            countries: [],
            selectedCountries: [],
            // Afrin :update 6-9
            temp_country: null,
            download_loader: false,
            download_text: '',
            loader: false
            // Afrin :update 6-9
        };
    },
    methods: {
        getNocs() {
            axios.get(this.pageurl + '/noc-document/list', { params: { bulk: 1 } })
                .then(response => {
                    this.noc_documents = response.data.noc_documents.map(noc => {
                        return {
                            ...noc,
                            // Afrin :update 6-9
                            employee_name: noc.employee ? noc.employee.name : '',
                            employee_code: noc.employee ? noc.employee.employee_code : '',
                            jobposition: noc.employee && noc.employee.jobposition ? noc.employee.jobposition.name : '',
                            worklocation: noc.employee && noc.employee.branch ? noc.employee.branch.name : '',
                            status_text: this.statusMap[noc.status] || ''
                        };
                    });
                    this.pagination.total = this.noc_documents.length;
                    this.pagination.pages = Math.ceil(this.noc_documents.length / this.length);
                })
                .catch(error => {
                    this.serverError(error);
                });
        },
        editNoc(id) {
            axios.get(this.pageurl + '/noc-document/details', { params: { id: id, bulk: 1 } })
                .then(response => {
                    this.fdata = response.data;
                    if (!this.fdata.noc_type) {
                        this.fdata.noc_type = 'travel';
                    }
                    this.selectedCountries = this.fdata.visiting_destination ? this.fdata.visiting_destination.split(',').map(c => c.trim()).filter(Boolean) : [];
                    this.$bvModal.show('bv-modal-noc');
                })
                .catch(error => {
                    this.serverError(error);
                });
        },
        // Afrin: 6-14 updated start
        deleteNoc(id) {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this application.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.post(this.pageurl + '/noc-document/delete', { id: id, bulk: 1 })
                        .then(response => {
                            if (response.data.status) {
                                this.showSuccessToast(response.data.meg);
                                this.selectedNocIds = this.selectedNocIds.filter(selectedId => selectedId !== id);
                                this.getNocs();
                            } else {
                                this.showErrorToast(response.data.meg || response.data.msg || 'Deletion failed.');
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        approveNoc(id, status) {
            let msg = status === 1 ? 'approve' : 'reject';
            this.$bvModal.msgBoxConfirm('Please confirm that you want to ' + msg + ' this NOC.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.post(this.pageurl + '/noc-document/approve', { id: id, status: status, bulk: 1 })
                        .then(response => {
                            if (response.data.status) {
                                this.showSuccessToast(response.data.meg);
                                this.getNocs();
                            } else {
                                this.showErrorToast(response.data.meg || response.data.msg || 'Approval failed.');
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        bulkApprove(status) {
            let msg = status === 1 ? 'approve' : 'reject';
            this.$bvModal.msgBoxConfirm('Please confirm that you want to ' + msg + ' all selected NOCs.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.post(this.pageurl + '/noc-document/approve', { id: this.selectedNocIds, status: status, bulk: 1 })
                        .then(response => {
                            if (response.data.status) {
                                this.showSuccessToast(response.data.meg);
                                this.selectedNocIds = [];
                                this.getNocs();
                            } else {
                                this.showErrorToast(response.data.meg || response.data.msg || 'Bulk action failed.');
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        bulkEmail(flag) {
            if (this.selectedNocIds.length === 0) {
                this.$bvModal.msgBoxConfirm('Please select NOC application(s).', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Ok',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                });
                return;
            }
            const hasApproved = this.noc_documents.some(noc => this.selectedNocIds.includes(noc.id) && noc.status == 1);
            if (!hasApproved) {
                this.$bvToast.toast("Only approved NOC documents can be emailed. None of the selected documents are approved.", {
                    title: 'Warning',
                    variant: 'warning',
                    solid: true
                });
                return;
            }
            const totalSelected = this.selectedNocIds.length;
            const approvedCount = this.noc_documents.filter(noc => this.selectedNocIds.includes(noc.id) && noc.status == 1).length;
            const nonApprovedCount = totalSelected - approvedCount;

            let confirmMsg = '';
            let actionMsg = flag === 1 ? 'save to employee profile and email' : 'email';
            if (nonApprovedCount > 0) {
                confirmMsg = `You have selected ${totalSelected} NOCs, but ${nonApprovedCount} are pending/rejected. Are you sure you want to ${actionMsg} only the ${approvedCount} approved NOC(s)?`;
            } else {
                confirmMsg = `Are you sure you want to ${actionMsg} all selected NOCs?`;
            }

            this.$bvModal.msgBoxConfirm(confirmMsg, {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    this.$bvToast.toast('We are processing email sending. Please wait...', {
                        title: 'Processing',
                        variant: 'info',
                        solid: true
                    });
                    axios.post(this.pageurl + '/noc-document/bulk-email', { ids: this.selectedNocIds, flag: flag })
                        .then(response => {
                            // Afrin :update 6-9
                            this.download_loader = false;
                            this.download_text = '';
                            // Afrin :update 6-9
                            if (response.data.status) {
                                this.showSuccessToast(response.data.msg);
                                this.selectedNocIds = [];
                                this.getNocs();
                            } else {
                                this.$bvToast.toast(response.data.msg, {
                                    title: 'Warning',
                                    variant: 'warning',
                                    solid: true
                                });
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        bulkDownload(flag) {
            if (this.selectedNocIds.length === 0) {
                this.$bvModal.msgBoxConfirm('Please select NOC application(s).', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Ok',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                });
                return;
            }
            const hasApproved = this.noc_documents.some(noc => this.selectedNocIds.includes(noc.id) && noc.status == 1);
            if (!hasApproved) {
                this.$bvToast.toast("Only approved NOC documents can be downloaded. None of the selected documents are approved.", {
                    title: 'Warning',
                    variant: 'warning',
                    solid: true
                });
                return;
            }
            const totalSelected = this.selectedNocIds.length;
            const approvedCount = this.noc_documents.filter(noc => this.selectedNocIds.includes(noc.id) && noc.status == 1).length;
            const nonApprovedCount = totalSelected - approvedCount;

            let confirmMsg = '';
            let actionMsg = flag === 1 ? 'save to employee profile and download' : 'download';
            if (nonApprovedCount > 0) {
                confirmMsg = `You have selected ${totalSelected} NOCs, but ${nonApprovedCount} are pending or rejected. Are you sure you want to ${actionMsg} only the ${approvedCount} approved NOC(s)?`;
            } else {
                confirmMsg = `Are you sure you want to ${actionMsg} all selected NOCs?`;
            }

            this.$bvModal.msgBoxConfirm(confirmMsg, {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    // Afrin :update 6-9
                    this.download_loader = true;
                    this.download_text = 'We are processing your download and this may take some time. Do not close this window until the download begins.';
                    // Afrin :update 6-9
                    axios.post(this.pageurl + '/noc-document/bulk-download', { ids: this.selectedNocIds, flag: flag })
                        .then(response => {
                            // Afrin :update 6-9
                            this.download_loader = false;
                            this.download_text = '';
                            // Afrin :update 6-9
                            if (response.data.status) {
                                this.showSuccessToast(response.data.msg);
                                this.selectedNocIds = [];
                                this.getNocs();

                                // Trigger zip download
                                if (response.data.file_link) {
                                    window.location.href = this.$api_url + '/templates/downloadzip?file_name=' + response.data.file_name + '&download_file_name=' + response.data.file_name + '&modification_flag=2';
                                }
                            } else {
                                this.$bvToast.toast(response.data.msg, {
                                    title: 'Warning',
                                    variant: 'warning',
                                    solid: true
                                });
                            }
                        })
                        .catch(error => {
                            // Afrin :update 6-9
                            this.download_loader = false;
                            this.download_text = '';
                            // Afrin :update 6-9
                            this.serverError(error);
                        });
                }
            });
        },
        bulkDelete() {
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete all selected NOC applications?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.post(this.pageurl + '/noc-document/delete', { id: this.selectedNocIds, bulk: 1 })
                        .then(response => {
                            if (response.data.status) {
                                this.showSuccessToast(response.data.meg);
                                this.selectedNocIds = [];
                                this.getNocs();
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        // Afrin: 6-14 updated end
        onCountrySelect(value) {
            if (value && !this.selectedCountries.includes(value)) {
                this.selectedCountries.push(value);
                this.fdata.visiting_destination = this.selectedCountries.join(', ');
            }
            this.temp_country = null;
        },
        removeCountry(country) {
            this.selectedCountries = this.selectedCountries.filter(c => c !== country);
            this.fdata.visiting_destination = this.selectedCountries.join(', ');
        },
        onSubmit() {
            if (this.fdata.noc_type === 'general') {
                this.fdata.nationality = '';
                this.fdata.passport_no = '';
                this.fdata.passport_issue_date = null;
                this.fdata.passport_expiry_date = null;
                this.fdata.visiting_destination = '';
            } else {
                this.fdata.visiting_destination = this.selectedCountries.join(', ');
            }
            this.loader = true; // afrin 6-11
            this.$validator.validateAll().then(result => {
                // afrin 6-11
                if (!result) {
                    this.loader = false;
                    return;
                }
                // afrin 6-11
                // Afrin :update 6-9
                if (this.fdata.visiting_from_date && this.fdata.visiting_to_date) {
                    const start = moment(this.fdata.visiting_from_date);
                    const end = moment(this.fdata.visiting_to_date);
                    if (end.isBefore(start, 'day')) {
                        this.veeErrors.add({
                            field: 'visiting_to_date',
                            msg: 'End Date cannot be earlier than Start Date.'
                        });
                        this.loader = false; // afrin 6-11
                        return;
                    }
                }
                 // afrin 6-11
                if (this.fdata.noc_type === 'travel' && this.fdata.passport_issue_date) {
                    const issue = moment(this.fdata.passport_issue_date);
                    const today = moment();
                    if (issue.isAfter(today, 'day')) {
                        this.veeErrors.add({
                            field: 'passport_issue_date',
                            msg: 'Passport Issue Date cannot be a future date.'
                        });
                        this.loader = false; // afrin 6-11
                        return;
                    }
                }
                if (this.fdata.noc_type === 'travel' && this.fdata.passport_issue_date && this.fdata.passport_expiry_date) {
                    const issue = moment(this.fdata.passport_issue_date);
                    const expiry = moment(this.fdata.passport_expiry_date);
                    if (expiry.isBefore(issue, 'day')) {
                        this.veeErrors.add({
                            field: 'passport_expiry_date',
                            msg: 'Passport Expiry Date cannot be earlier than Passport Issue Date.'
                        });
                        this.loader = false; // afrin 6-11
                        return;
                    }
                }
                // afrin 6-11
                if (this.fdata.noc_type === 'travel' && this.fdata.passport_expiry_date) {
                    const expiry = moment(this.fdata.passport_expiry_date);
                    if (this.fdata.visiting_from_date) {
                        const start = moment(this.fdata.visiting_from_date);
                        if (start.isAfter(expiry, 'day')) {
                            this.veeErrors.add({
                                field: 'visiting_from_date',
                                msg: 'Start Date cannot be after Passport Expiry Date.'
                            });
                            this.loader = false; // afrin 6-11
                            return;
                        }
                    }
                    if (this.fdata.visiting_to_date) {
                        const end = moment(this.fdata.visiting_to_date);
                        if (end.isAfter(expiry, 'day')) {
                            this.veeErrors.add({
                                field: 'visiting_to_date',
                                msg: 'End Date cannot be after Passport Expiry Date.'
                            });
                            this.loader = false; // afrin 6-11
                            return;
                        }
                    }
                }
                // Afrin :update 6-9

                axios.post(this.pageurl + '/noc-document/save', { ...this.fdata, bulk: 1 })
                    .then(response => {
                        this.loader = false; // afrin 6-11
                        if (response.data.status) {
                            this.showSuccessToast(response.data.msg);
                            this.$bvModal.hide('bv-modal-noc');
                            this.getNocs();
                        } else {
                            this.showErrorToast(response.data.msg || 'Save failed.');
                        }
                    })
                    .catch(error => {
                        this.loader = false; //afrin 6-11
                        this.serverError(error);
                    });
                     // afrin 6-11
            }).catch(() => {
                this.loader = false;
            // afrin 6-11
            });
        },
        format_date(date) {
            if (date) {
                return moment(date).format('DD-MMM-YYYY');
            }
            return '';
        },
        format_datetime(date) {
            if (date) {
                return moment(date).format('DD-MMM-YYYY hh:mm A');
            }
            return '';
        },
        resetPagination() {
            this.pagination.currentPage = 1;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.resetPagination();
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        showSuccessToast(msg) {
            this.$bvToast.toast(msg, {
                title: 'Success',
                variant: 'success',
                solid: true
            });
        },
        showErrorToast(msg) {
            this.$bvToast.toast(msg, {
                title: 'Error',
                variant: 'danger',
                solid: true
            });
        },
        getCountries() {
            axios.get(this.pageurl + '/noc-document/countries')
                .then(response => {
                    this.countries = response.data;
                })
                .catch(error => {
                    this.serverError(error);
                });
        },
        // Afrin: edited 6-25-26 start
        getCountryText(value) {
            if (!value) return '';
            const country = this.countries.find(c => String(c.value) === String(value));
            return country ? country.text : value;
        }
        // Afrin: edited 6-25-26 end
    },
    computed: {
        selectAll: {
            // afrin 6-11
        maxPassportIssueDate() {
            return moment().format('YYYY-MM-DD');
        },
            get() {
                return this.filteredData.length > 0 && this.selectedNocIds.length === this.filteredData.length; // Afrin :update 6-9
            },
            set(value) {
                const selected = [];
                if (value) {
                    this.filteredData.forEach(noc => { // Afrin :update 6-9
                        selected.push(noc.id);
                    });
                }
                this.selectedNocIds = selected;
            }
        },
        filteredData() {
            let filtered_list = this.noc_documents;
            if (this.filter_year) {
                filtered_list = filtered_list.filter((row) => {
                    return row.fiscal_year === this.filter_year;
                });
            }
            if (this.filter_month) {
                filtered_list = filtered_list.filter((row) => {
                    return row.month == this.filter_month;
                });
            }
            if (this.filter_status !== '') {
                filtered_list = filtered_list.filter((row) => {
                    return row.status == this.filter_status;
                });
            }
            if (this.search) {
                filtered_list = filtered_list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key] || '').toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    });
                });
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let a_val = a[sortKey];
                    let b_val = b[sortKey];

                    if (sortKey === 'employee_name') {
                        // Afrin :update 6-9
                        a_val = a.employee ? a.employee.name : '';
                        b_val = b.employee ? b.employee.name : '';
                    } else if (sortKey === 'employee_code') {
                        a_val = a.employee ? a.employee.employee_code : '';
                        b_val = b.employee ? b.employee.employee_code : '';
                    } else if (sortKey === 'jobposition') {
                        a_val = a.employee && a.employee.jobposition ? a.employee.jobposition.name : '';
                        b_val = b.employee && b.employee.jobposition ? b.employee.jobposition.name : '';
                    } else if (sortKey === 'worklocation') {
                        a_val = a.employee && a.employee.branch ? a.employee.branch.name : '';
                        b_val = b.employee && b.employee.branch ? b.employee.branch.name : '';
                    } else if (sortKey === 'updated_at') {
                        a_val = a.updated_at || a.created_at || '';
                        b_val = b.updated_at || b.created_at || '';
                    }

                    if (a_val === null) a_val = '';
                    if (b_val === null) b_val = '';

                    a_val = String(a_val).toLowerCase();
                    b_val = String(b_val).toLowerCase();

                    if (!isNaN(parseFloat(a_val)) && !isNaN(parseFloat(b_val)) && isFinite(a_val) && isFinite(b_val)) {
                        return (+a_val === +b_val ? 0 : +a_val > +b_val ? 1 : -1) * order;
                    } else {
                        return (a_val === b_val ? 0 : a_val > b_val ? 1 : -1) * order;
                    }
                });
            }

            return filtered_list;
        },
        paginatedData() {
            if (this.paginate) {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            } else {
                const start = (this.pagination.currentPage - 1) * this.length;
                const end = start + this.length;
                return this.filteredData.slice(start, end);
            }
        }
    },
    created() {
        this.getNocs();
        this.getCountries();
    }
};
</script>
